/* no-results.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./no-results.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import { Grid, Text } from '@atlaskit/primitives/compiled';
import { useDatasourceAnalyticsEvents } from '../../../analytics';
import { SpotSearchNoResult } from '../../../common/ui/spot/error-state/search-no-result';
import { loadingErrorMessages } from './messages';
var styles = {
  noResultsContainerStyles: "_4cvr1h6o _6a6z1h6o _1wpz1h6o _10fp1h6o _19pkoahv _2hwxoahv _otyroahv _18u0oahv",
  noResultsContentStyles: "_zulp1ejb _4cvr1h6o _6a6z1h6o _p12fko4j",
  noResultsMessageContainerStyles: "_zulppxbi _4cvr1h6o _6a6z1h6o _y3gn1h6o"
};
export var NoResults = function NoResults(_ref) {
  var onRefresh = _ref.onRefresh;
  var _useDatasourceAnalyti = useDatasourceAnalyticsEvents(),
    fireEvent = _useDatasourceAnalyti.fireEvent;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  useEffect(function () {
    fireEvent('ui.emptyResult.shown.datasource', {});
  }, [fireEvent]);
  return /*#__PURE__*/React.createElement(Grid, {
    xcss: styles.noResultsContainerStyles,
    testId: "datasource-modal--no-results"
  }, /*#__PURE__*/React.createElement(Grid, {
    xcss: styles.noResultsContentStyles
  }, /*#__PURE__*/React.createElement(SpotSearchNoResult, {
    size: 'xlarge',
    alt: formatMessage(loadingErrorMessages.noResultsFound)
  }), /*#__PURE__*/React.createElement(Grid, {
    xcss: styles.noResultsMessageContainerStyles
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    size: "large",
    weight: "bold"
  }, /*#__PURE__*/React.createElement(FormattedMessage, loadingErrorMessages.noResultsFound)), /*#__PURE__*/React.createElement(Text, {
    as: "span",
    size: "medium"
  }, /*#__PURE__*/React.createElement(FormattedMessage, loadingErrorMessages.noResultsFoundDescription)), onRefresh && /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    onClick: onRefresh
  }, /*#__PURE__*/React.createElement(FormattedMessage, loadingErrorMessages.refresh)))));
};